<template lang="pug">
div
  el-row
    el-col(:span="12")
      div(
        v-if="cadastroOriginal.cadastrante.pessoa.pessoaFisica && cadastroOriginal.cadastrante.pessoa.pessoaFisica.cpf",
        key="pessoaFisica"
      )
        app-display(
          label="CPF:",
          :content="cadastroOriginal.cadastrante.pessoa.pessoaFisica.cpf",
          v-if="cadastroOriginal.cadastrante.pessoa.pessoaFisica.cpf"
          :class = "compararCadastranteAreasPatrimoniais && compararCadastranteAreasPatrimoniais.mudouPessoa.mudouCPF ? 'text': '' "
        )
        app-display(
          label="Nome:",
          :content="cadastroOriginal.cadastrante.pessoa.pessoaFisica.nome"
          :class = "compararCadastranteAreasPatrimoniais && compararCadastranteAreasPatrimoniais.mudouPessoa.mudouNome ? 'text': '' "
        )
        app-display(
          label="Matrícula:",
          :content="cadastroOriginal.cadastrante.pessoa.pessoaFisica.matricula"
          :class = "compararCadastranteAreasPatrimoniais && compararCadastranteAreasPatrimoniais.mudouPessoa.mudouMatricula ? 'text': '' "
        )
      div(v-if="cadastroOriginal.cadastrante.pessoa.pessoaJuridica && cadastroOriginal.cadastrante.pessoa.pessoaJuridica.cnpj")
        app-display(
          label="CNPJ:",
          :content="cadastroOriginal.cadastrante.pessoa.pessoaJuridica.cnpj",
          :class = "compararCadastranteAreasPatrimoniais && compararCadastranteAreasPatrimoniais.mudouPessoa.mudouCNPJ ? 'text': '' "
        )
        app-display(
          label="Razão Social:",
          :content="cadastroOriginal.cadastrante.pessoa.pessoaJuridica.razaoSocial || '-'",
          :class = "compararCadastranteAreasPatrimoniais && compararCadastranteAreasPatrimoniais.mudouPessoa.mudouRazaoSocial ? 'text': '' "
        )
    el-col(:span="12")
      app-display-multiple(
        label="Telefone(s):",
        :content="cadastroOriginal.cadastrante.pessoa.telefones"
        :class = "compararCadastranteAreasPatrimoniais && compararCadastranteAreasPatrimoniais.mudouPessoa.mudouTelefones ? 'text': '' "
      )
      app-display(
        label="E-mail:",
        :content="cadastroOriginal.cadastrante.pessoa.email"
        :class = "compararCadastranteAreasPatrimoniais && compararCadastranteAreasPatrimoniais.mudouPessoa.mudouEmail ? 'text': '' "
      )
  el-row
    el-col
      app-collapse(title="Solicitação")
        p.conteudo(v-html="cadastroOriginal.cadastrante.solicitacao")
        listagem-documentos(
          :documentos="[cadastroOriginal.cadastrante.oficio]",
          :protocoloCadastroOriginal="cadastroOriginal.protocolo",
          ownerDocumento="OFICIO"
          :compararDocumentos = "compararCadastranteAreasPatrimoniais && compararCadastranteAreasPatrimoniais.mudouDocumentosCadastrante"
          :versaoCadastro = "versaoCadastro"
        )
  el-row
    el-col
      app-collapse(title="Endereço")
        informacoes-endereco(:endereco="enderecoCadastrante", slot="body", :mudouEndereco="compararCadastranteAreasPatrimoniais && compararCadastranteAreasPatrimoniais.mudouEndereco")

</template>

<script>
import AppDisplay from '@/components/AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import AppCollapse from '@/components/AppCollapse'

import InformacoesEndereco from '@/components/informacoesCadastro/common/InformacoesEndereco'
import ListagemDocumentos from '@/components/informacoesCadastro/common/ListagemDocumentos'

export default {
  props: {
    cadastroOriginal: {
      type: Object,
      required: true
    },
    compararCadastranteAreasPatrimoniais: {
      type: Object,
      required: true
    },
    versaoCadastro: {
      type: String,
      default: 'MAX(versao_json)'
    }
  },

  components: {
    AppDisplay,
    InformacoesEndereco,
    ListagemDocumentos,
    AppCollapse,
    AppDisplayMultiple
  },

  computed: {
    enderecoCadastrante () {
      return this.cadastroOriginal.cadastrante.pessoa.endereco ? this.cadastroOriginal.cadastrante.pessoa.endereco : {}
    }
  }
}
</script>

<style lang="scss" scoped>
  .conteudo {
    font-size: 14px;
  }
  >>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/areasPatrimoniais/InformacoesCadastranteAreasPatrimoniais.vue